import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import numeral from "numeral";

import { treasurySnapshotGetHistoricalDataBySymbol, treasurySnapshotGetLatestRateBySymbol } from "../../../modals/TestHarnessCashflowModal/treasurySnapshot.store";
import { BreakevenLineChart } from "../../../pdf-export-templates";

import { ValueTypes } from "./constants";
import "./styles.css";

const RefiBreakevenModule = ({
  data = {},
  treasurySnapshotGetHistoricalDataBySymbol,
  treasurySnapshotGetLatestRateBySymbol,
  snapshot,
  treasuryLabel
}) => {
  const {
    breakevenSpread,
    breakevenTreasury,
    interestSavings,
    currentTreasury,
    PV01,
    netCostToRefi,
    prepaymentPenalty
  } = data;

  const displayValues = [
    {
      label: "Prepay Penalty",
      value: prepaymentPenalty,
      valueType: ValueTypes.currency
    },
    {
      label: "Interest Savings",
      value: interestSavings,
      valueType: ValueTypes.currency
    },
    {
      label: "Present Value of 1 Basis Point",
      value: PV01,
      valueType: ValueTypes.currency
    },
    {
      label: `${treasuryLabel} Yield`,
      value: currentTreasury,
      valueType: ValueTypes.percent
    },
    {
      label: `Breakeven ${treasuryLabel}`,
      value: breakevenTreasury,
      valueType: ValueTypes.percent
    },
    {
      label: "Breakeven Spread",
      value: breakevenSpread,
      valueType: ValueTypes.percent,
      prefix: true
    }
  ];

  useEffect(() => {
    treasurySnapshotGetHistoricalDataBySymbol({ symbol: "TREASURY Y10" });
    treasurySnapshotGetLatestRateBySymbol({ symbol: "TREASURY Y10" });
  }, []);

  return (
    <div className="supervised-analysis-body-wrapper">
      <div className="supervised-analysis-body-chart-wrapper">
        <BreakevenLineChart
          companyPrimaryColor="#005AA9"
          companySecondaryColor="#0F9AD6"
          snapshot={snapshot}
          providedCurrentRate={currentTreasury}
          providedBreakevenRate={breakevenTreasury}
          treasuryLabel={treasuryLabel}
        />
      </div>
      <div className="supervised-analysis-body-stats-wrapper">
        <div className="supervised-stats-layout supervised-stats-header">
          <div>Net Cost to Refi</div>
          <div>{netCostToRefi ? numeral(netCostToRefi).format("$0,0") : "--"}</div>
        </div>
        {displayValues.map(({ label, value, prefix, valueType }, idx) => <div className="supervised-stats-layout supervised-stats-body" key={idx}>
          <div>{label}</div>
          {valueType === ValueTypes.currency && value >= 0 && <div>{value ? numeral(value).format("$0,0.00") : "--"}</div>}
          {valueType === ValueTypes.currency && value < 0 && <div>{value ? `(${numeral(Math.abs(value)).format("$0,0.00")})` : "--"}</div>}
          {valueType === ValueTypes.percent && <div>
            {prefix ? "+" : ""}
            {value ? numeral(value).format("0,0.00%") : "--"}
          </div>}
        </div>)}
      </div>
    </div>
  );
};

const mapStateToProps = ({ treasurySnapshot }) => ({ snapshot: treasurySnapshot });

export default compose(withRouter, connect(mapStateToProps, {
  treasurySnapshotGetHistoricalDataBySymbol,
  treasurySnapshotGetLatestRateBySymbol
}))(RefiBreakevenModule);
